import React, { useState } from "react";
import CustomeButton from "~/components/Button";
import ShareRegistryTable from "./ShareRegistryTable";
import AddTransactionModal from "./modal/AddTransactionModal";
import PropTypes from "prop-types";
import ShareholderRegistered from "../ShareholderRegistered";

const ShareRegistry = ({
  shareRegistryData,
  setShareRegistryData,
  modalVisible,
  setModalVisible,
  transaction,
  setTransaction,
  formatDate,
  isCongrats,
  setIsCongrats,
  setActiveIndex,
  resetRegData,
}) => {
  const [edit, setEdit] = useState(false);
  const [rowIndex, setRowIndex] = useState();
  const editTransactionHandler = (data, index) => {
    setEdit(true);
    setModalVisible(true);
    setTransaction(data);
    setRowIndex(index);
  };

  const closeModal = () => {
    setModalVisible(false);
    setEdit(false);
    setTransaction({});
    setRowIndex("");
  };
  return (
    <>
      {!isCongrats ? (
        <div className="share-registry-table-container">
          <div className="table-header-container">
            <div className="title-container">
              <p className="table-title">Share Registry</p>
              <p className="table-title-description">
                Keep an accurate and auditable record of ownership changes and
                manage shareholding information
              </p>
            </div>
            <CustomeButton
              label="Add Share Transaction"
              className="add-transaction-button"
              icon="pi pi-plus"
              iconPos="right"
              onClick={() => setModalVisible(true)}
            />
          </div>

          {/* Share Registry Table */}
          <ShareRegistryTable
            shareRegistryData={shareRegistryData}
            setModalVisible={setModalVisible}
            formatDate={formatDate}
            editTransactionHandler={editTransactionHandler}
            isEditing={false}
          />
          {/* Transaction Modal */}
          {modalVisible && (
            <AddTransactionModal
              visible={modalVisible}
              setModalVisible={setModalVisible}
              transaction={transaction}
              setTransaction={setTransaction}
              setShareRegistryData={setShareRegistryData}
              edit={edit}
              setEdit={setEdit}
              rowIndex={rowIndex}
              setRowIndex={setRowIndex}
              closeModal={closeModal}
              isEditing={false}
            />
          )}
        </div>
      ) : (
        <ShareholderRegistered
          setActiveIndex={setActiveIndex}
          resetRegData={resetRegData}
          setIsCongrats={setIsCongrats}
        />
      )}
    </>
  );
};

ShareRegistry.propTypes = {
  shareRegistryData: PropTypes.array,
  setShareRegistryData: PropTypes.func,
  modalVisible: PropTypes.bool,
  setModalVisible: PropTypes.func,
  transaction: PropTypes.object,
  setTransaction: PropTypes.func,
  formatDate: PropTypes.func,
  isCongrats: PropTypes.bool,
  setIsCongrats: PropTypes.func,
  setActiveIndex: PropTypes.func,
  resetRegData: PropTypes.func,
};

export default ShareRegistry;
